import styled from "styled-components";
import theme from "common/theme";
export const GeneratorChartGridContainer = styled.div`
 
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
 

    .grid-line {
      position: absolute;

      &.vertical {
        height: 100%;
        width: 0;
        top: 0;
        border-left: 1px solid ${theme?.colors?.gridLine};
        transform: translateX(-1px);
      }

      &.horizontal {
        width: 100%;
        left: 0;
        border-top: 1px solid ${theme?.colors?.gridLine};
        transform: translateY(-1px);
      }
    }

`